import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import DomainPortfolio from "@/pages/DomainPortfolio";
import SoftwarePortfolio from "@/pages/SoftwarePortfolio";
import About from "@/pages/About";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import MySubmissions from "@/pages/MySubmissions";
import "@/App.css";

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}

// Render AuthCallback FIRST if session_id is in URL fragment (synchronous, prevents race conditions)
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=") || window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
      <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
      <Route path="/domain-portfolio" element={<SiteLayout><DomainPortfolio /></SiteLayout>} />
      <Route path="/software-portfolio" element={<SiteLayout><SoftwarePortfolio /></SiteLayout>} />
      <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
      <Route path="/investors" element={<SiteLayout><Investors /></SiteLayout>} />
      <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
      <Route path="/my-submissions" element={<SiteLayout><MySubmissions /></SiteLayout>} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            color: "#0F172A",
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
